import { BaseApi } from './base.api.js';

export class AuditFindingApi extends BaseApi {
    constructor(client) {
        super(client, '/audit-finding');
    }
}
